import { commonServerInstance } from '@/utilities/instances'
import { commonDownloadService } from './common'

export interface ISLAExtensionUploadResult {
  status: 'success' | 'failed'
  message: string
  totalRecords: number
  processed: number
  failed: number
  errors?: {
    invalidTNOs?: Array<{ row: number; tno: string; issue: string }>
    invalidReasons?: Array<{
      row: number
      tno: string
      reason: string
      issue: string
    }>
    generalErrors?: Array<string>
  }
}

export interface ISLAExtensionHistory {
  batch_id: number
  original_file_name: string
  uploaded_at: string
  total_records: number
  processed_records: number
  failed_records: number
  batch_status: 'success' | 'failed'
  uploaded_by: string
}

export interface ISLAExtensionResponse {
  data: ISLAExtensionHistory[]
}

/**
 * Upload SLA extension request file
 * @param file Excel file containing SLA extension requests
 * @returns Upload result
 */
export const uploadSLAExtensionRequest = async (
  file: File
): Promise<ISLAExtensionUploadResult> => {
  const formData = new FormData()
  formData.append('file', file)

  const response = await commonServerInstance.post(
    '/api/v1/sla-extensions/upload',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )

  return response.data
}

export const downloadSLAExtensionTemplate = async (): Promise<void> => {
  return await commonDownloadService('/api/v1/sla-extensions/template/download')
}

/**
 * Fetch SLA extension request history
 * @param params Query parameters
 * @returns SLA extension history
 */
export const fetchSLAExtensionHistory = async (params: {
  limit?: number
}): Promise<ISLAExtensionHistory[]> => {
  const response = await commonServerInstance.get(
    '/api/v1/sla-extensions/upload-history',
    {
      params
    }
  )

  return response?.data?.data
}
